import { useEffect } from "react";
import { notifyPageView } from "../../analytics/useAnalyticsEventTracker";
import {
	DATA_TYPES,
	EMPTY_MESSAGES,
	EMPTY_MESSAGE_IMAGES,
} from "../../constants";
import { setMetaTags } from "../../helpers/pageMeta";
import { stateType } from "../../state";
import { EmptyMessage } from "../Common/EmptyMessage";
import { useStyles } from "../DataIngestion/DataIngestion";
import {
	ClassSelectDropdown,
	ImpactDropdown,
	VariableImpactBox,
} from "./VariableImpactBox";
import { VariableImportanceBox } from "./VariableImportanceBox";

export function VariableImportance({ state }: stateType) {
	const classes = useStyles();
	useEffect(() => {
		setMetaTags();
		window.scrollTo(0, 0);
		notifyPageView("Variable Importance Page", window.location.pathname);
	}, []);
	const col = state.saveState.dataset.getColumn(
		state.saveState.modelTraining.valueToPredict
	);
	if (col === undefined) {
		return <div></div>;
	}
	const isCat = col.columnType === DATA_TYPES.categorical;
	const isEmpty =
		Object.keys(state.saveState.variableImportance.varImportance).length ===
		0;

	if (state.saveState.savedModels.length === 0) {
		return (
			<EmptyMessage
				image={EMPTY_MESSAGE_IMAGES.pleaseTrain}
				message1={EMPTY_MESSAGES.train1}
				message2={EMPTY_MESSAGES.train2}
			></EmptyMessage>
		);
	} else {
		return (
			<div className={classes.root}>
				<div className={classes.grid}>
					<div className={classes.title}>Variable Importance</div>
				</div>
				<div className={classes.grid}>
					<div className={classes.subTitle}>
						See how your input variables affect the target variable
						chosen in the 'Model Training' tab.
					</div>
				</div>
				<div className={classes.grid}>
					<VariableImportanceBox
						state={state}
					></VariableImportanceBox>
				</div>
				<div className={classes.divider2}></div>
				{isEmpty ? (
					<div></div>
				) : (
					<div className={classes.grid} style={{ marginTop: "30px" }}>
						<div className={classes.title}>
							Variable Impact Analysis
						</div>
					</div>
				)}
				{isEmpty ? (
					<div></div>
				) : (
					<div className={classes.grid}>
						<div
							style={{
								height: "40px",
								width: "100%",
								display: "flex",
								flexDirection: "row",
								marginBottom: "0px",
								marginTop: "0px",
								zIndex: 100,
								marginLeft: "-40px",
							}}
						>
							<ImpactDropdown state={state}></ImpactDropdown>
							{isCat ? (
								<ClassSelectDropdown
									state={state}
								></ClassSelectDropdown>
							) : (
								<div></div>
							)}
						</div>
					</div>
				)}
				{isEmpty ? (
					<div></div>
				) : (
					<div className={classes.grid}>
						<VariableImpactBox state={state}></VariableImpactBox>
					</div>
				)}
			</div>
		);
	}
}
